import script from "./StylingAndComfortDW5V2.vue?vue&type=script&setup=true&lang=js"
export * from "./StylingAndComfortDW5V2.vue?vue&type=script&setup=true&lang=js"

import "./StylingAndComfortDW5V2.vue?vue&type=style&index=0&id=6f10f285&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f10f285"]])

export default __exports__